var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 805",
    style: {
      enableBackground: "new 0 0 1920 805"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000012468562436898427320000004584359730873924772_);}\r\n\t.st1{fill:url(#SVGID_00000044172389517008099940000000289080863677706626_);}\r\n\t.st2{fill:url(#SVGID_00000086661197517665670100000010078318585628106674_);}\r\n\t.st3{fill:url(#SVGID_00000107563273711610730130000003665750714660231321_);}\r\n\t.st4{fill:url(#SVGID_00000085234506371486185400000015601663664996159913_);}\r\n\t.st5{fill:url(#SVGID_00000088822275961578664200000013552048656094440613_);}\r\n\t.st6{fill:#4F4F4F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -178,
    width: 2295,
    height: 375.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013167757965203520960000001371212240523285926_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013167757965203520960000001371212240523285926_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057125534628840170310000012009289476556239282_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.1208,
    y1: 277.8582,
    x2: 223.1208,
    y2: -397.3082,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 63.4174 796.4479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0099FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09670413,
    style: {
      stopColor: "#0FB2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2345,
    style: {
      stopColor: "#20CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    style: {
      stopColor: "#2DE4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#37F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7327,
    style: {
      stopColor: "#3CFCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057125534628840170310000012009289476556239282_)"
    },
    d: "M598.2,845.7L598.2,845.7 c-93.9,93.9-246,93.9-339.9,0L120.7,708.2c-93.9-93.9-93.9-246,0-339.9l0,0L598.2,845.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098184119267741340830000005837985388852218265_",
    gradientUnits: "userSpaceOnUse",
    x1: -152.4255,
    y1: 580.814,
    x2: -152.4255,
    y2: -10.6384,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 724.1974 150.3538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D33A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    style: {
      stopColor: "#A832C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    style: {
      stopColor: "#CE32DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    style: {
      stopColor: "#E931EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4767,
    style: {
      stopColor: "#F931F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5571,
    style: {
      stopColor: "#FF31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098184119267741340830000005837985388852218265_)"
    },
    d: "M290.7,538.2l-170-170L369,120 c93.9-93.9,246-93.9,339.9,0L290.7,538.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144318730878419526650000010929616830845659064_",
    gradientUnits: "userSpaceOnUse",
    x1: -81.1098,
    y1: 70.2358,
    x2: -81.1098,
    y2: -608.7612,
    gradientTransform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1378.3656 237.7006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0099FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09670413,
    style: {
      stopColor: "#0FB2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2345,
    style: {
      stopColor: "#20CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    style: {
      stopColor: "#2DE4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5456,
    style: {
      stopColor: "#37F3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7327,
    style: {
      stopColor: "#3CFCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144318730878419526650000010929616830845659064_)"
    },
    d: "M1205,119.6c93.9-93.9,246-93.9,339.9,0 l140.2,140.2c93.9,93.9,93.9,246,0,339.9l0,0L1205,119.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072257288156007690280000010184308882429763519_",
    gradientUnits: "userSpaceOnUse",
    x1: -363.1122,
    y1: 885.043,
    x2: -363.1122,
    y2: 293.5908,
    gradientTransform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 717.5856 883.7947)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D33A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    style: {
      stopColor: "#A832C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    style: {
      stopColor: "#CE32DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3714,
    style: {
      stopColor: "#E931EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4767,
    style: {
      stopColor: "#F931F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5571,
    style: {
      stopColor: "#FF31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072257288156007690280000010184308882429763519_)"
    },
    d: "M1515.2,429.8l170,170L1436.9,848 c-93.9,93.9-246,93.9-339.9,0L1515.2,429.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105396762798863646320000013574137446280988820_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.3424,
    y1: 556.5214,
    x2: 510.3424,
    y2: -232.5524,
    gradientTransform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1378.3656 237.7006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8733FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#531DB5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000105396762798863646320000013574137446280988820_)"
    },
    points: "539,290 709,120.1 1266.9,678  1097,848  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.7,576h-89.8V541h22.5V436.2h-22.5v-34.9h89.8v34.9h-22.5V541h22.5V576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2,477.4c-8.8,0-18.8,1.7-29.9,5V576h-43.7V443.7h38.7l2.5,12.5c7.8-5.2,15.8-8.9,24.1-11.4c8.2-2.4,15.2-3.6,20.8-3.6 h11.2c11.3,0,20.4,3.4,27.2,10.2c6.8,6.8,10.2,15.9,10.2,27.2V576h-43.7v-89.8c0-2.5-0.8-4.6-2.5-6.2c-1.7-1.7-3.7-2.5-6.2-2.5 H289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.2,576c-16.1,1.7-31.9,2.5-47.4,2.5c-11.3,0-20.4-3.4-27.2-10.2c-6.8-6.8-10.2-15.9-10.2-27.2v-63.6h-15v-33.7h15 l5-29.9H424v29.9h31.2v33.7H424v57.4c0,2.5,0.8,4.6,2.5,6.2c1.7,1.7,3.7,2.5,6.2,2.5h32.4V576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.9,573.5c-32.1,3.3-61.2,5-87.3,5c-11.3,0-20.4-3.4-27.2-10.2c-6.8-6.8-10.2-15.9-10.2-27.2v-59.9 c0-12.5,3.5-22.2,10.6-29.3c7.1-7.1,16.8-10.6,29.3-10.6H570c12.5,0,22.2,3.5,29.3,10.6c7.1,7.1,10.6,16.8,10.6,29.3v46.2h-86.1v10 c0,2.5,0.8,4.6,2.5,6.2c1.7,1.7,3.7,2.5,6.2,2.5c16.5,0,40.6-1.2,72.4-3.7V573.5z M533.8,472.4c-6.7,0-10,3.3-10,10v13.7h42.4 v-13.7c0-6.7-3.3-10-10-10H533.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.4,479.9c-10.5,0-21.3,2.5-32.4,7.5V576h-43.7V443.7H671l2.5,16.2c14.3-12.5,29.3-18.7,44.9-18.7h11.2v38.7H708.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.7,477.4c-8.8,0-18.8,1.7-29.9,5V576h-43.7V443.7h38.7l2.5,12.5c7.8-5.2,15.8-8.9,24.1-11.4c8.2-2.4,15.2-3.6,20.8-3.6 h11.2c11.3,0,20.4,3.4,27.2,10.2c6.8,6.8,10.2,15.9,10.2,27.2V576h-43.7v-89.8c0-2.5-0.8-4.6-2.5-6.2c-1.7-1.7-3.7-2.5-6.2-2.5 H820.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.6,446.2c30.4-3.3,57.9-5,82.3-5c11.3,0,20.4,3.4,27.2,10.2c6.8,6.8,10.2,15.9,10.2,27.2V576h-38.7l-2.5-12.5 c-7.8,5.2-15.8,8.9-24.1,11.4c-8.2,2.4-15.2,3.6-20.8,3.6h-8.7c-11.3,0-20.4-3.4-27.2-10.2c-6.8-6.8-10.2-15.9-10.2-27.2v-11.2 c0-11.3,3.4-20.4,10.2-27.2c6.8-6.8,15.9-10.2,27.2-10.2h51.2v-10c0-2.5-0.8-4.6-2.5-6.2c-1.7-1.7-3.7-2.5-6.2-2.5 c-10.8,0-22.7,0.5-35.8,1.5c-13.1,1-23.6,1.7-31.6,2.2V446.2z M956.7,543.5c8.8,0,18.8-1.7,29.9-5v-15h-36.2 c-2.5,0-4.6,0.8-6.2,2.5c-1.7,1.7-2.5,3.7-2.5,6.2v2.5c0,2.5,0.8,4.6,2.5,6.2c1.7,1.7,3.7,2.5,6.2,2.5H956.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.1,576c-16.1,1.7-31.9,2.5-47.4,2.5c-11.3,0-20.4-3.4-27.2-10.2c-6.8-6.8-10.2-15.9-10.2-27.2v-63.6h-15v-33.7h15 l5-29.9h38.7v29.9h31.2v33.7h-31.2v57.4c0,2.5,0.8,4.6,2.5,6.2c1.7,1.7,3.7,2.5,6.2,2.5h32.4V576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.5,448.7V576h-43.7v-93.6h-18.7v-33.7H1217.5z M1173.8,398.8h43.7v34.9h-43.7V398.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.2,538.6c0,12.5-3.5,22.2-10.6,29.3c-7.1,7.1-16.8,10.6-29.3,10.6h-57.4c-12.5,0-22.2-3.5-29.3-10.6 c-7.1-7.1-10.6-16.8-10.6-29.3v-57.4c0-12.5,3.5-22.2,10.6-29.3c7.1-7.1,16.8-10.6,29.3-10.6h57.4c12.5,0,22.2,3.5,29.3,10.6 c7.1,7.1,10.6,16.8,10.6,29.3V538.6z M1333.5,484.9c0-6.7-3.3-10-10-10h-29.9c-6.7,0-10,3.3-10,10v49.9c0,6.7,3.3,10,10,10h29.9 c6.7,0,10-3.3,10-10V484.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.2,477.4c-8.8,0-18.8,1.7-29.9,5V576h-43.7V443.7h38.7l2.5,12.5c7.8-5.2,15.8-8.9,24.1-11.4 c8.2-2.4,15.2-3.6,20.8-3.6h11.2c11.3,0,20.4,3.4,27.2,10.2c6.8,6.8,10.2,15.9,10.2,27.2V576h-43.7v-89.8c0-2.5-0.8-4.6-2.5-6.2 c-1.7-1.7-3.7-2.5-6.2-2.5H1473.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563,446.2c30.4-3.3,57.9-5,82.3-5c11.3,0,20.4,3.4,27.2,10.2c6.8,6.8,10.2,15.9,10.2,27.2V576h-38.7l-2.5-12.5 c-7.8,5.2-15.8,8.9-24.1,11.4c-8.2,2.4-15.2,3.6-20.8,3.6h-8.7c-11.3,0-20.4-3.4-27.2-10.2c-6.8-6.8-10.2-15.9-10.2-27.2v-11.2 c0-11.3,3.4-20.4,10.2-27.2c6.8-6.8,15.9-10.2,27.2-10.2h51.2v-10c0-2.5-0.8-4.6-2.5-6.2c-1.7-1.7-3.7-2.5-6.2-2.5 c-10.8,0-22.7,0.5-35.8,1.5c-13.1,1-23.6,1.7-31.6,2.2V446.2z M1609.2,543.5c8.8,0,18.8-1.7,29.9-5v-15H1603 c-2.5,0-4.6,0.8-6.2,2.5c-1.7,1.7-2.5,3.7-2.5,6.2v2.5c0,2.5,0.8,4.6,2.5,6.2c1.7,1.7,3.7,2.5,6.2,2.5H1609.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.6,576c-11.1,1.7-21.8,2.5-31.8,2.5c-10.1,0-18.5-3.4-25.3-10.2c-6.8-6.8-10.2-15.9-10.2-27.2V401.3h43.7v133.5 c0,2.5,0.8,4.6,2.5,6.2c1.7,1.7,3.7,2.5,6.2,2.5h15V576z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.4,748.2h-56.6v-22H120v-66h-14.1v-22h56.6v22h-14.1v66h14.1V748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230,748.2h-28.3v-88h-33v-22H263v22h-33V748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.9,725.4c28.7,1.6,48.1,2.4,58.3,2.4c2.4,0,4.3-0.7,5.7-2.1c1.4-1.4,2.1-3.3,2.1-5.7v-14.1h-36.2 c-11,0-19-2.5-24-7.5c-5-5-7.5-13-7.5-24v-4.7c0-11,2.5-19,7.5-24c5-5,13-7.5,24-7.5h55.2v22h-48.9c-6.3,0-9.4,3.1-9.4,9.4v3.1 c0,6.3,3.1,9.4,9.4,9.4h28.3c10.3,0,17.8,2.4,22.6,7.2c4.8,4.8,7.2,12.4,7.2,22.6v7.9c0,10.3-2.4,17.8-7.2,22.6 c-4.8,4.8-12.4,7.2-22.6,7.2c-5.3,0-11-0.1-17-0.3l-14.5-0.6c-10.7-0.5-21.7-1.3-33.2-2.2V725.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452.4,715.2v33h-27.5v-110h27.5v55.8H465l17.3-29.1h29.1l-23.6,40.1l23.6,43.2h-29.1l-18.1-33H452.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M553.8,668v80.2h-27.5v-58.9h-11.8V668H553.8z M526.3,636.6h27.5v22h-27.5V636.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M611.9,748.2c-7,1-13.7,1.6-20,1.6c-6.3,0-11.7-2.1-16-6.4c-4.3-4.3-6.4-10-6.4-17.1v-88H597v84.1 c0,1.6,0.5,2.9,1.6,3.9c1,1.1,2.4,1.6,3.9,1.6h9.4V748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M665.4,748.2c-7,1-13.7,1.6-20,1.6c-6.3,0-11.7-2.1-16-6.4c-4.3-4.3-6.4-10-6.4-17.1v-88h27.5v84.1 c0,1.6,0.5,2.9,1.6,3.9c1,1.1,2.4,1.6,3.9,1.6h9.4V748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M673.2,726.2c21.3,1.6,38,2.4,50.3,2.4c1.6,0,2.9-0.5,3.9-1.6c1-1,1.6-2.4,1.6-3.9v-5.5h-33.8 c-7.1,0-12.8-2.1-17.1-6.4c-4.3-4.3-6.4-10-6.4-17.1v-5.5c0-7.1,2.1-12.8,6.4-17.1c4.3-4.3,10-6.4,17.1-6.4h53.4v20.4h-44 c-1.6,0-2.9,0.5-3.9,1.6c-1.1,1.1-1.6,2.4-1.6,3.9c0,1.6,0.5,2.9,1.6,3.9c1,1.1,2.4,1.6,3.9,1.6H733c7.1,0,12.8,2.1,17.1,6.4 c4.3,4.3,6.4,10,6.4,17.1v6.3c0,7.1-2.1,12.8-6.4,17.1s-10,6.4-17.1,6.4c-18.5,0-38.5-1-59.7-3.1V726.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M901.1,746.6c-23.4,2.1-42.8,3.1-58.2,3.1c-10.3,0-17.8-2.4-22.6-7.2c-4.8-4.8-7.2-12.4-7.2-22.6v-50.3 c0-11,2.5-19,7.5-24c5-5,13-7.5,24-7.5h56.6v22h-50.3c-6.3,0-9.4,3.1-9.4,9.4v50.3c0,2.4,0.7,4.3,2.1,5.7c1.4,1.4,3.2,2.1,5.4,2.1 c2.2,0,4.6,0,7.2-0.1c2.6-0.1,5.3-0.1,8.2-0.2c2.8-0.1,5.7-0.2,8.6-0.3c2.9-0.1,6.6-0.3,11.2-0.6c4.6-0.3,10.2-0.7,17.1-1.1V746.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M997,724.6c0,7.9-2.2,14-6.7,18.5c-4.5,4.5-10.6,6.7-18.5,6.7h-36.2c-7.9,0-14-2.2-18.5-6.7 c-4.5-4.5-6.7-10.6-6.7-18.5v-36.2c0-7.9,2.2-14,6.7-18.5c4.5-4.5,10.6-6.7,18.5-6.7h36.2c7.9,0,14,2.2,18.5,6.7 c4.5,4.5,6.7,10.6,6.7,18.5V724.6z M969.5,690.8c0-4.2-2.1-6.3-6.3-6.3h-18.9c-4.2,0-6.3,2.1-6.3,6.3v31.4c0,4.2,2.1,6.3,6.3,6.3 h18.9c4.2,0,6.3-2.1,6.3-6.3V690.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1066.9,663.3c8.5,0,15,3.1,19.6,9.4c4.8-3.2,10-5.6,15.6-7.1c5.6-1.5,10.6-2.3,15-2.3h1.6 c7.1,0,12.8,2.1,17.1,6.4c4.3,4.3,6.4,10,6.4,17.1v61.3h-27.5v-56.6c0-1.6-0.5-2.9-1.6-3.9s-2.4-1.6-3.9-1.6h-0.8 c-4.7,0-10.7,1-18.1,3.1v58.9H1063v-56.6c0-1.6-0.5-2.9-1.6-3.9s-2.4-1.6-3.9-1.6h-0.8c-4.7,0-10.7,1-18.1,3.1v58.9h-27.5v-83.3 h24.4l1.6,7.9c4.9-3.2,10-5.6,15.2-7.1c5.2-1.5,9.6-2.3,13.1-2.3H1066.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1184,748.2v26.7h-27.5v-110h24.4l1.6,7.9c4.9-3.2,10-5.6,15.2-7.1c5.2-1.5,9.6-2.3,13.1-2.3h7.1 c7.1,0,12.8,2.1,17.1,6.4c4.3,4.3,6.4,10,6.4,17.1V723c0,7.9-2.2,14-6.7,18.5c-4.5,4.5-10.6,6.7-18.5,6.7H1184z M1202.9,686.1 c-5.6,0-11.8,1-18.9,3.1V727h23.6c4.2,0,6.3-2.1,6.3-6.3v-29.1c0-1.6-0.5-2.9-1.6-3.9s-2.4-1.6-3.9-1.6H1202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1332.6,746.6c-20.2,2.1-38.6,3.1-55,3.1c-7.1,0-12.8-2.1-17.1-6.4c-4.3-4.3-6.4-10-6.4-17.1v-37.7 c0-7.9,2.2-14,6.7-18.5c4.5-4.5,10.6-6.7,18.5-6.7h31.4c7.9,0,14,2.2,18.5,6.7c4.5,4.5,6.7,10.6,6.7,18.5v29.1h-54.2v6.3 c0,1.6,0.5,2.9,1.6,3.9c1,1.1,2.4,1.6,3.9,1.6c10.4,0,25.6-0.8,45.6-2.4V746.6z M1287.8,682.9c-4.2,0-6.3,2.1-6.3,6.3v8.6h26.7 v-8.6c0-4.2-2.1-6.3-6.3-6.3H1287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1408,748.2c-10.2,1-20.1,1.6-29.9,1.6c-7.1,0-12.8-2.1-17.1-6.4s-6.4-10-6.4-17.1v-40.1h-9.4v-21.2h9.4 l3.1-18.9h24.4v18.9h19.6v21.2h-19.6v36.2c0,1.6,0.5,2.9,1.6,3.9c1,1.1,2.4,1.6,3.9,1.6h20.4V748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1453.6,668v80.2h-27.5v-58.9h-11.8V668H1453.6z M1426.1,636.6h27.5v22h-27.5V636.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1527.5,748.2c-10.2,1-20.1,1.6-29.9,1.6c-7.1,0-12.8-2.1-17.1-6.4s-6.4-10-6.4-17.1v-40.1h-9.4v-21.2h9.4 l3.1-18.9h24.4v18.9h19.6v21.2h-19.6v36.2c0,1.6,0.5,2.9,1.6,3.9c1,1.1,2.4,1.6,3.9,1.6h20.4V748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1573,668v80.2h-27.5v-58.9h-11.8V668H1573z M1545.5,636.6h27.5v22h-27.5V636.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1673.6,724.6c0,7.9-2.2,14-6.7,18.5c-4.5,4.5-10.6,6.7-18.5,6.7h-36.2c-7.9,0-14-2.2-18.5-6.7 c-4.5-4.5-6.7-10.6-6.7-18.5v-36.2c0-7.9,2.2-14,6.7-18.5c4.5-4.5,10.6-6.7,18.5-6.7h36.2c7.9,0,14,2.2,18.5,6.7 c4.5,4.5,6.7,10.6,6.7,18.5V724.6z M1646.1,690.8c0-4.2-2.1-6.3-6.3-6.3H1621c-4.2,0-6.3,2.1-6.3,6.3v31.4c0,4.2,2.1,6.3,6.3,6.3 h18.9c4.2,0,6.3-2.1,6.3-6.3V690.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1734.1,686.1c-5.6,0-11.8,1-18.9,3.1v58.9h-27.5v-83.3h24.4l1.6,7.9c4.9-3.2,10-5.6,15.2-7.1 c5.2-1.5,9.6-2.3,13.1-2.3h7.1c7.1,0,12.8,2.1,17.1,6.4c4.3,4.3,6.4,10,6.4,17.1v61.3h-27.5v-56.6c0-1.6-0.5-2.9-1.6-3.9 s-2.4-1.6-3.9-1.6H1734.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f047c7564b97d3da65ab0b834225e9c5.svg";
export { ForwardRef as ReactComponent };